import React from 'react';
import { calculateReviews, Colors, getStars, Images, PermissionsList, RolePermission, userType } from 'utils';
import { IconAndTitle, MinLoader, PhoneRow, TextRow, TextToolTip, TypeRow } from 'components';
import { Rating } from '@material-ui/lab';
import { styled } from '@material-ui/core';
import { carrierIntegrationEnums, highwayConStatus } from '../../fragments/carriers/carrierInfo/core/constants';

const StyledRating = styled(Rating)({
  '& .MuiRating-iconFilled': {
    color: '#438BFE',
  },
  '& .MuiRating-iconHover': {
    color: '#438BFE',
  },
  '& .MuiRating-iconEmpty': {
    color: '#BFE0FF',
  },
});

export const vendorEnums = {
  CARRIER: 'CARRIER',
  CO_BROKER: 'CO_BROKER',
  WAREHOUSE: 'WAREHOUSE',
  CUSTOM_BROKER: 'CUSTOM_BROKER',
  FREIGHT_FORWARDER: 'FREIGHT_FORWARDER',
  INTERMODAL_FREIGHT_FORWARDER: 'INT_FREIGHT',
  FACTORED: 'FACTOR_CARRIER',
  VENDOR: 'VENDOR',
  INHOUSE_PROFILE: 'CONNECTING',
};

export const VendorTables = (type = vendorEnums.CARRIER, info) => {
  switch (type) {
    case vendorEnums.CARRIER:
      return {
        title: 'Carrier',
        type: vendorEnums.CARRIER,
        head:
          [
            { name: 'companyName', title: 'Company Name', searchKey: 'companyName' },
            { name: 'docketNumber', title: 'Authority Number', searchKey: 'docketNumber' },
            { name: 'name', title: 'Carrier Name' },
            { name: 'phone', title: 'Phone Number', custom: false, searchKey: 'phone' },
            { name: '', title: 'Rating', custom: false, searchKey: '' },
            RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.CREATE_UPDATE_CARRIER?.code]) &&
            !info?.highwayOnboard &&
            { name: '', title: 'App Invitation', custom: false },
            !info?.highwayOnboard &&
            { name: '', title: 'RMIS / GoHighway', custom: false },
            info?.highwayOnboard &&
            { name: '', title: 'USDOT Number', custom: false },
            info?.highwayOnboard &&
            { name: '', title: 'Connection Status', custom: false },
            { name: '', title: 'Status', custom: false },
          ],
        body: (loaders) => {
          return [
            { rowText: (item) => <IconAndTitle icon={Images.carrier} title={item?.companyName} textWidth={10} /> },
            { rowText: (item) => <TextRow name={item?.docketNumber} textWidth={10} /> },
            { rowText: (item) => <TextRow name={`${item?.firstName} ${item?.lastName}`} textWidth={10} /> },
            { rowText: (item) => <PhoneRow phone={item?.phone} /> },
            {
              rowText: (item) => {
                const { ratings, amount } = getStars(item?.reviews?.stars);

                const rating = calculateReviews(ratings, amount);

                if (rating && rating !== 0 && !isNaN(rating)) {
                  const fixedRating = +rating.toFixed(1);

                  return (
                    <div className="align-center" style={{ gap: '4px' }}>
                      <StyledRating
                        readOnly
                        name="simple-controlled"
                        max={1}
                        precision={0.1}
                        value={fixedRating / 5}
                      />

                      <TextToolTip text={`${fixedRating}/5 (${amount})`} content={`${fixedRating}/5 (${amount})`} />
                    </div>
                  );
                } else {
                  return (
                    <div className="align-center" style={{ gap: '4px' }}>
                      <StyledRating
                        readOnly
                        name="simple-controlled"
                        max={1}
                        precision={0.5}
                        value={0}
                      />

                      <TextToolTip text={'0'} content={'0'} />
                    </div>
                  );
                }
              },
            },

            RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.CREATE_UPDATE_CARRIER?.code]) &&
            !info?.highwayOnboard &&
            { button: (item, info) => renderAppInvitation(item, info, loaders), notClickable: true },
            !info?.highwayOnboard &&
            { button: (item, info) => renderRmis(item, info, loaders), notClickable: true },
            info?.highwayOnboard &&
            { rowText: (item) => <TextRow name={item?.dot} textWidth={10} /> },
            info?.highwayOnboard &&
            { rowText: (item) => <TypeRow text={highwayConStatus[item?.highwayConStatus]}/> },
            { button: (item, info) => renderStatus(item, info, loaders), notClickable: true },
          ];
        },
        vendorCsv: {
          type: 'carrier',
          statusList: carrierStatuses,
          requiredStatus: true,
          statusEnum: 'statuses',
          statusesEnum: statusesEnum,
          w9: true,
        },
      };

    case vendorEnums.CO_BROKER:
      return {
        title: 'Co-Broker',
        type: vendorEnums.CO_BROKER,
        head: [
          { name: 'companyName', title: 'Company Name', searchKey: 'companyName' },
          { name: 'docketNumber', title: 'Authority Number', searchKey: 'docketNumber' },
          { name: 'name', title: 'Co-Broker' },
          { name: 'phone', title: 'Phone Number', custom: false, searchKey: 'phone' },
          { name: '', title: 'Rating', custom: false, searchKey: '' },
          { name: '', title: 'Status', custom: false },
        ],
        body: (loaders) => {
          return [
            { rowText: (item) => <IconAndTitle icon={Images.carrier} title={item?.companyName} textWidth={10} /> },
            { rowText: (item) => <TextRow name={item?.docketNumber} textWidth={10} /> },
            { rowText: (item) => <TextRow name={`${item?.firstName} ${item?.lastName}`} textWidth={10} /> },
            { rowText: (item) => <PhoneRow phone={item?.phone} /> },
            {
              rowText: (item) => {
                const { ratings, amount } = getStars(item?.reviews?.stars);

                const rating = calculateReviews(ratings, amount);

                if (rating && rating !== 0 && !isNaN(rating)) {
                  const fixedRating = +rating.toFixed(1);

                  return (
                    <div className="align-center" style={{ gap: '4px' }}>
                      <StyledRating
                        readOnly
                        name="simple-controlled"
                        max={1}
                        precision={0.1}
                        value={fixedRating / 5}
                      />

                      <TextToolTip text={`${fixedRating}/5 (${amount})`} content={`${fixedRating}/5 (${amount})`} />
                    </div>
                  );
                } else {
                  return (
                    <div className="align-center" style={{ gap: '4px' }}>
                      <StyledRating
                        readOnly
                        name="simple-controlled"
                        max={1}
                        precision={0.5}
                        value={0}
                      />

                      <TextToolTip text={'0'} content={'0'} />
                    </div>
                  );
                }
              },
            },
            { button: (item, info) => renderStatus(item, info, loaders), notClickable: true },
          ];
        },
        vendorCsv: {
          type: 'carrier',
          statusList: carrierStatusesNoPending,
          requiredStatus: true,
          statusEnum: 'statuses',
          statusesEnum: statusesEnum,
          w9: true,
        },
      };

    case vendorEnums.WAREHOUSE:
      return {
        title: 'Warehouse',
        type: vendorEnums.WAREHOUSE,
        head: [
          { name: 'companyName', title: 'Company Name', searchKey: 'companyName' },
          { name: 'docketNumber', title: 'Authority Number', searchKey: 'docketNumber' },
          { name: '', title: 'Warehouse', custom: false },
          { name: 'phone', title: 'Phone Number', custom: false, searchKey: 'phone' },
          { name: '', title: 'Rating', custom: false, searchKey: '' },
          { name: '', title: 'Status', custom: false },
        ],
        body: (loaders) => {
          return [
            { rowText: (item) => <IconAndTitle icon={Images.carrier} title={item?.companyName} textWidth={10} /> },
            { rowText: (item) => <TextRow name={item?.docketNumber} textWidth={10} /> },
            { rowText: (item) => <TextRow name={`${item?.firstName} ${item?.lastName}`} textWidth={10} /> },
            { rowText: (item) => <PhoneRow phone={item?.phone} /> },
            {
              rowText: (item) => {
                const { ratings, amount } = getStars(item?.reviews?.stars);

                const rating = calculateReviews(ratings, amount);

                if (rating && rating !== 0 && !isNaN(rating)) {
                  const fixedRating = +rating.toFixed(1);

                  return (
                    <div className="align-center" style={{ gap: '4px' }}>
                      <StyledRating
                        readOnly
                        name="simple-controlled"
                        max={1}
                        precision={0.1}
                        value={fixedRating / 5}
                      />

                      <TextToolTip text={`${fixedRating}/5 (${amount})`} content={`${fixedRating}/5 (${amount})`} />
                    </div>
                  );
                } else {
                  return (
                    <div className="align-center" style={{ gap: '4px' }}>
                      <StyledRating
                        readOnly
                        name="simple-controlled"
                        max={1}
                        precision={0.5}
                        value={0}
                      />

                      <TextToolTip text={'0'} content={'0'} />
                    </div>
                  );
                }
              },
            },
            { button: (item, info) => renderStatus(item, info, loaders), notClickable: true },
          ];
        },
        vendorCsv: {
          type: 'carrier',
          statusList: carrierStatusesNoPending,
          requiredStatus: true,
          statusEnum: 'statuses',
          statusesEnum: statusesEnum,
          w9: true,
        },
      };

    case vendorEnums.CUSTOM_BROKER:
      return {
        title: 'Custom Broker',
        type: vendorEnums.CUSTOM_BROKER,
        head: [
          { name: 'companyName', title: 'Company Name', searchKey: 'companyName' },
          { name: '', title: 'CBP Licence Number', custom: false },
          { name: '', title: 'Custom Broker', custom: false },
          { name: 'phone', title: 'Phone Number', custom: false, searchKey: 'phone' },
          { name: '', title: 'Rating', custom: false, searchKey: '' },
          { name: '', title: 'Status', custom: false },
        ],
        body: (loaders) => {
          return [
            { rowText: (item) => <IconAndTitle icon={Images.carrier} title={item?.companyName} textWidth={10} /> },
            { rowText: (item) => <TextRow name={item?.docketNumber} textWidth={10} /> },
            { rowText: (item) => <TextRow name={`${item?.firstName} ${item?.lastName}`} textWidth={10} /> },
            { rowText: (item) => <PhoneRow phone={item?.phone} /> },
            {
              rowText: (item) => {
                const { ratings, amount } = getStars(item?.reviews?.stars);

                const rating = calculateReviews(ratings, amount);

                if (rating && rating !== 0 && !isNaN(rating)) {
                  const fixedRating = +rating.toFixed(1);

                  return (
                    <div className="align-center" style={{ gap: '4px' }}>
                      <StyledRating
                        readOnly
                        name="simple-controlled"
                        max={1}
                        precision={0.1}
                        value={fixedRating / 5}
                      />

                      <TextToolTip text={`${fixedRating}/5 (${amount})`} content={`${fixedRating}/5 (${amount})`} />
                    </div>
                  );
                } else {
                  return (
                    <div className="align-center" style={{ gap: '4px' }}>
                      <StyledRating
                        readOnly
                        name="simple-controlled"
                        max={1}
                        precision={0.5}
                        value={0}
                      />

                      <TextToolTip text={'0'} content={'0'} />
                    </div>
                  );
                }
              },
            },
            { button: (item, info) => renderStatus(item, info, loaders), notClickable: true },
          ];
        },
        vendorCsv: {
          type: 'carrier',
          statusList: carrierStatusesNoPending,
          requiredStatus: true,
          statusEnum: 'statuses',
          statusesEnum: statusesEnum,
          w9: true,
        },
      };

    case vendorEnums.FREIGHT_FORWARDER:
      return {
        title: 'Freight Forwarder',
        type: vendorEnums.FREIGHT_FORWARDER,
        head: [
          { name: 'companyName', title: 'Company Name', searchKey: 'companyName' },
          { name: '', title: 'FF Number', custom: false },
          { name: '', title: 'Freight Forwarder', custom: false },
          { name: 'phone', title: 'Phone Number', custom: false, searchKey: 'phone' },
          { name: '', title: 'Rating', custom: false, searchKey: '' },
          { name: '', title: 'Status', custom: false },
        ],
        body: (loaders) => {
          return [
            { rowText: (item) => <IconAndTitle icon={Images.carrier} title={item?.companyName} textWidth={10} /> },
            { rowText: (item) => <TextRow name={item?.docketNumber} textWidth={10} /> },
            { rowText: (item) => <TextRow name={`${item?.firstName} ${item?.lastName}`} textWidth={10} /> },
            { rowText: (item) => <PhoneRow phone={item?.phone} /> },
            {
              rowText: (item) => {
                const { ratings, amount } = getStars(item?.reviews?.stars);

                const rating = calculateReviews(ratings, amount);

                if (rating && rating !== 0 && !isNaN(rating)) {
                  const fixedRating = +rating.toFixed(1);

                  return (
                    <div className="align-center" style={{ gap: '4px' }}>
                      <StyledRating
                        readOnly
                        name="simple-controlled"
                        max={1}
                        precision={0.1}
                        value={fixedRating / 5}
                      />

                      <TextToolTip text={`${fixedRating}/5 (${amount})`} content={`${fixedRating}/5 (${amount})`} />
                    </div>
                  );
                } else {
                  return (
                    <div className="align-center" style={{ gap: '4px' }}>
                      <StyledRating
                        readOnly
                        name="simple-controlled"
                        max={1}
                        precision={0.5}
                        value={0}
                      />

                      <TextToolTip text={'0'} content={'0'} />
                    </div>
                  );
                }
              },
            },
            { button: (item, info) => renderStatus(item, info, loaders), notClickable: true },
          ];
        },
        vendorCsv: {
          type: 'carrier',
          statusList: carrierStatusesNoPending,
          requiredStatus: true,
          statusEnum: 'statuses',
          statusesEnum: statusesEnum,
          w9: true,
        },
      };

    case vendorEnums.INTERMODAL_FREIGHT_FORWARDER:
      return {
        title: 'Int. Freight',
        type: vendorEnums.INTERMODAL_FREIGHT_FORWARDER,
        head: [
          { name: 'companyName', title: 'Company Name', searchKey: 'companyName' },
          { name: 'docketNumber', title: 'Authority Number', searchKey: 'docketNumber' },
          { name: '', title: 'Int. Freight', custom: false },
          { name: 'phone', title: 'Phone Number', custom: false, searchKey: 'phone' },
          { name: '', title: 'Rating', custom: false, searchKey: '' },
          { name: '', title: 'Status', custom: false },
        ],
        body: (loaders) => {
          return [
            { rowText: (item) => <IconAndTitle icon={Images.carrier} title={item?.companyName} textWidth={10} /> },
            { rowText: (item) => <TextRow name={item?.docketNumber} textWidth={10} /> },
            { rowText: (item) => <TextRow name={`${item?.firstName} ${item?.lastName}`} textWidth={10} /> },
            { rowText: (item) => <PhoneRow phone={item?.phone} /> },
            {
              rowText: (item) => {
                const { ratings, amount } = getStars(item?.reviews?.stars);

                const rating = calculateReviews(ratings, amount);

                if (rating && rating !== 0 && !isNaN(rating)) {
                  const fixedRating = +rating.toFixed(1);

                  return (
                    <div className="align-center" style={{ gap: '4px' }}>
                      <StyledRating
                        readOnly
                        name="simple-controlled"
                        max={1}
                        precision={0.1}
                        value={fixedRating / 5}
                      />

                      <TextToolTip text={`${fixedRating}/5 (${amount})`} content={`${fixedRating}/5 (${amount})`} />
                    </div>
                  );
                } else {
                  return (
                    <div className="align-center" style={{ gap: '4px' }}>
                      <StyledRating
                        readOnly
                        name="simple-controlled"
                        max={1}
                        precision={0.5}
                        value={0}
                      />

                      <TextToolTip text={'0'} content={'0'} />
                    </div>
                  );
                }
              },
            },
            { button: (item, info) => renderStatus(item, info, loaders), notClickable: true },
          ];
        },
        vendorCsv: {
          type: 'carrier',
          statusList: carrierStatusesNoPending,
          requiredStatus: true,
          statusEnum: 'statuses',
          statusesEnum: statusesEnum,
        },
      };

    case vendorEnums.FACTORED:
      return {
        title: 'Factored Carrier',
        type: vendorEnums.FACTORED,
        head: [
          { name: 'companyName', title: 'Company Name', searchKey: 'companyName' },
          { name: 'docketNumber', title: 'Authority Number', searchKey: 'docketNumber' },
          { name: '', title: 'Factored Carrier', custom: false },
          { name: 'phone', title: 'Phone Number', custom: false, searchKey: 'phone' },
          { name: '', title: 'Rating', custom: false, searchKey: '' },
          { name: '', title: 'App Invitation', custom: false },
          { name: '', title: 'Status', custom: false },
        ],
        body: (loaders) => {
          return [
            { rowText: (item) => <IconAndTitle icon={Images.carrier} title={item?.companyName} textWidth={10} /> },
            { rowText: (item) => <TextRow name={item?.docketNumber} textWidth={10} /> },
            { rowText: (item) => <TextRow name={`${item?.firstName} ${item?.lastName}`} textWidth={10} /> },
            { rowText: (item) => <PhoneRow phone={item?.phone} /> },
            {
              rowText: (item) => {
                const { ratings, amount } = getStars(item?.reviews?.stars);

                const rating = calculateReviews(ratings, amount);

                if (rating && rating !== 0 && !isNaN(rating)) {
                  const fixedRating = +rating.toFixed(1);

                  return (
                    <div className="align-center" style={{ gap: '4px' }}>
                      <StyledRating
                        readOnly
                        name="simple-controlled"
                        max={1}
                        precision={0.1}
                        value={fixedRating / 5}
                      />

                      <TextToolTip text={`${fixedRating}/5 (${amount})`} content={`${fixedRating}/5 (${amount})`} />
                    </div>
                  );
                } else {
                  return (
                    <div className="align-center" style={{ gap: '4px' }}>
                      <StyledRating
                        readOnly
                        name="simple-controlled"
                        max={1}
                        precision={0.5}
                        value={0}
                      />

                      <TextToolTip text={'0'} content={'0'} />
                    </div>
                  );
                }
              },
            },
            { button: (item, info) => renderAppInvitation(item, info, loaders), notClickable: true },
            { button: (item, info) => renderStatus(item, info, loaders), notClickable: true },
          ];
        },
        vendorCsv: {
          type: 'carrier',
          statusList: carrierStatusesNoPending,
          requiredStatus: true,
          statusEnum: 'statuses',
          statusesEnum: statusesEnum,
          w9: true,
        },
      };

    case vendorEnums.VENDOR:
      return {
        title: 'Vendor',
        type: vendorEnums.VENDOR,
        head: [
          { name: 'companyName', title: 'Company Name', searchKey: 'companyName' },
          { name: '', title: 'Vendor Name', custom: false },
          { name: 'phone', title: 'Phone Number', custom: false, searchKey: 'phone' },
          { name: '', title: 'Rating', custom: false, searchKey: '' },
          { name: '', title: 'Status', custom: false },
        ],
        body: (loaders) => {
          return [
            { rowText: (item) => <IconAndTitle icon={Images.carrier} title={item?.companyName} /> },
            { rowText: (item) => <TextRow name={`${item?.firstName} ${item?.lastName}`} /> },
            { rowText: (item) => <PhoneRow phone={item?.phone} /> },
            {
              rowText: (item) => {
                const { ratings, amount } = getStars(item?.reviews?.stars);

                const rating = calculateReviews(ratings, amount);

                if (rating && rating !== 0 && !isNaN(rating)) {
                  const fixedRating = +rating.toFixed(1);

                  return (
                    <div className="align-center" style={{ gap: '4px' }}>
                      <StyledRating
                        readOnly
                        name="simple-controlled"
                        max={1}
                        precision={0.1}
                        value={fixedRating / 5}
                      />

                      <TextToolTip text={`${fixedRating}/5 (${amount})`} content={`${fixedRating}/5 (${amount})`} />
                    </div>
                  );
                } else {
                  return (
                    <div className="align-center" style={{ gap: '4px' }}>
                      <StyledRating
                        readOnly
                        name="simple-controlled"
                        max={1}
                        precision={0.5}
                        value={0}
                      />

                      <TextToolTip text={'0'} content={'0'} />
                    </div>
                  );
                }
              },
            },
            { button: (item, info) => renderStatus(item, info, loaders), notClickable: true },
          ];
        },
        vendorCsv: {
          type: 'carrier',
          statusList: carrierStatusesNoPending,
          requiredStatus: true,
          statusEnum: 'statuses',
          statusesEnum: statusesEnum,
          w9: true,
        },
      };

    case vendorEnums.INHOUSE_PROFILE:
      return {
        title: 'Inhouse Profile',
        type: vendorEnums.INHOUSE_PROFILE,
        head: [
          { name: 'companyName', title: 'Company Name', searchKey: 'companyName' },
          { name: '', title: 'Inhouse Profile', custom: false },
          { name: 'phone', title: 'Phone Number', custom: false, searchKey: 'phone' },
          { name: '', title: 'Rating', custom: false, searchKey: '' },
          { name: '', title: 'Status', custom: false },
        ],
        body: (loaders) => {
          return [
            { rowText: (item) => <IconAndTitle icon={Images.carrier} title={item?.companyName} /> },
            { rowText: (item) => <TextRow name={`${item?.firstName} ${item?.lastName}`} /> },
            { rowText: (item) => <PhoneRow phone={item?.phone} /> },
            {
              rowText: (item) => {
                const { ratings, amount } = getStars(item?.reviews?.stars);

                const rating = calculateReviews(ratings, amount);

                if (rating && rating !== 0 && !isNaN(rating)) {
                  const fixedRating = +rating.toFixed(1);

                  return (
                    <div className="align-center" style={{ gap: '4px' }}>
                      <StyledRating
                        readOnly
                        name="simple-controlled"
                        max={1}
                        precision={0.1}
                        value={fixedRating / 5}
                      />

                      <TextToolTip text={`${fixedRating}/5 (${amount})`} content={`${fixedRating}/5 (${amount})`} />
                    </div>
                  );
                } else {
                  return (
                    <div className="align-center" style={{ gap: '4px' }}>
                      <StyledRating
                        readOnly
                        name="simple-controlled"
                        max={1}
                        precision={0.5}
                        value={0}
                      />

                      <TextToolTip text={'0'} content={'0'} />
                    </div>
                  );
                }
              },
            },
            { button: (item, info) => renderStatus(item, info, loaders), notClickable: true },
          ];
        },
        vendorCsv: {
          type: 'carrier',
          statusList: carrierStatusesNoPending,
          requiredStatus: true,
          statusEnum: 'statuses',
          statusesEnum: statusesEnum,
        },
      };

    default:
      return {
        title: 'Carrier',
        type: vendorEnums.CARRIER,
        head: [
          { name: 'companyName', title: 'Company Name', searchKey: 'companyName' },
          { name: 'docketNumber', title: 'Authority Number', searchKey: 'docketNumber' },
          { name: 'name', title: 'Carrier Name' },
          { name: 'phone', title: 'Phone Number', custom: false, searchKey: 'phone' },
          { name: '', title: 'Rating', custom: false, searchKey: '' },
          RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.CREATE_UPDATE_CARRIER?.code]) &&
          { name: '', title: 'App Invitation', custom: false },
          { name: '', title: 'RMIS', custom: false },
          { name: '', title: 'Status', custom: false },
        ],
        body: (loaders) => {
          return [
            { rowText: (item) => <IconAndTitle icon={Images.carrier} title={item?.companyName} textWidth={10} /> },
            { rowText: (item) => <TextRow name={item?.docketNumber} textWidth={10} /> },
            { rowText: (item) => <TextRow name={`${item?.firstName} ${item?.lastName}`} textWidth={10} /> },
            { rowText: (item) => <PhoneRow phone={item?.phone} /> },
            {
              rowText: (item) => {
                const { ratings, amount } = getStars(item?.reviews?.stars);
                const rating = calculateReviews(ratings, amount);
                if (rating && rating !== 0 && !isNaN(rating)) {
                  const fixedRating = +rating.toFixed(1);

                  return (
                    <div className="align-center" style={{ gap: '4px' }}>
                      <StyledRating
                        readOnly
                        name="simple-controlled"
                        max={1}
                        precision={0.1}
                        value={fixedRating / 5}
                      />

                      <TextToolTip text={`${fixedRating}/5 (${amount})`} content={`${fixedRating}/5 (${amount})`} />
                    </div>
                  );
                } else {
                  return (
                    <div className="align-center" style={{ gap: '4px' }}>
                      <StyledRating
                        readOnly
                        name="simple-controlled"
                        max={1}
                        precision={0.5}
                        value={0}
                      />

                      <TextToolTip text={'0'} content={'0'} />
                    </div>
                  );
                }
              },
            },
            RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.CREATE_UPDATE_CARRIER?.code]) &&
            { button: (item, info) => renderAppInvitation(item, info, loaders), notClickable: true },
            { button: (item, info) => renderRmis(item, info, loaders), notClickable: true },
            { button: (item, info) => renderStatus(item, info, loaders), notClickable: true },
          ];
        },
        vendorCsv: {
          type: 'carrier',
          statusList: carrierStatuses,
          requiredStatus: true,
          statusEnum: 'statuses',
          statusesEnum: statusesEnum,
          w9: true,
        },
      };
  }
};

export const ACTION_TYPE = 'GET_CARRIERS';
const renderRmis = (data, info, loaders) => {

  if (info?.onboardingSource === carrierIntegrationEnums.NONE) {
    return (
      <div className={'reinviteRmisWrapper'}>
        <p>None</p>
      </div>
    );
  }
  if (info?.rmisStatus === 'INACTIVE') {
    return (
      <div className={'reinviteRmisWrapper'}>
        <p>Inactive</p>
        {userType === 'ADMIN' &&
          <button
            onClick={() => data('rmisInvite')}
          >
            {loaders?.loadRmis?.length && loaders?.id === info?.id ?
              <MinLoader style={{ margin: 0, position: 'relative' }} color={Colors.ThemeBlue} />
              :
              'Reinvite'
            }
          </button>
        }
      </div>
    );
  } else if (info?.rmisStatus === 'ACTIVE') {
    return (
      <div className={'reinviteRmisWrapper'}>
        <p>Active</p>
      </div>
    );
  }
};

const renderAppInvitation = (data, info, loaders) => {
  const checkReInvite = info?.isFactored ? appStatus?.PENDING === info?.appStatus : appStatus?.INACTIVE === info?.appStatus;
  if (checkReInvite) {
    return (
      <div className={'reinviteRmisWrapper'}>
        <p>Inactive</p>
        <button
          onClick={() => data('appReInvitation')}
        >
          {loaders?.reInviteLoader?.length && info?.id === loaders?.id ?
            <MinLoader style={{ margin: 0, position: 'relative' }} color={Colors.ThemeBlue} />
            :
            'ReInvite'
          }
        </button>
      </div>
    );
  } else if (appStatus?.ACTIVE === info?.appStatus) {
    return (
      <div className={'reinviteRmisWrapper'}>
        <p>Active</p>
      </div>
    );
  } else {
    return '';
  }
};


const renderStatus = (data, info, loaders) => {
  if (info?.status === statusesEnum?.ACTIVE) {
    return (
      <div className={'reinviteRmisWrapper'}>
        <p>Active</p>
      </div>
    );
  } else if (info?.status === statusesEnum?.INACTIVE) {
    return (
      <div className={'reinviteRmisWrapper'}>
        <p>Inactive</p>
      </div>
    );
  } else if (info?.status === statusesEnum?.PENDING) {
    return (
      <div className="acceptDenyWrapper">
        {loaders?.acceptDenyLoader?.length && info?.id === loaders?.id ?
          <MinLoader style={{ margin: 0, position: 'relative' }} color={Colors.ThemeBlue} />
          :
          <>
            <button onClick={() => data('accept')}>
              <img src={Images.approveIcon} alt="icons" />
            </button>
            <button onClick={() => data('deny')}>
              <img src={Images.clear} alt="icons" />
            </button>
          </>
        }
      </div>
    );
  } else {
    return '';
  }
};

export const appStatus = {
  PENDING: 1,
  ACTIVE: 2,
  INACTIVE: 3,
};
export const carrierStatuses = [
  // { id: 'All', name: 'All' },
  { id: 'ACTIVE', name: 'Active' },
  { id: 'INACTIVE', name: 'Inactive' },
  { id: 'PENDING', name: 'Pending' },
];
export const carrierStatusesNoPending = [
  // { id: 'All', name: 'All' },
  { id: 'ACTIVE', name: 'Active' },
  { id: 'INACTIVE', name: 'Inactive' },
];
export const carrierStatusesEnum = [
  { id: 'ACTIVE', name: 'Active' },
  { id: 'INACTIVE', name: 'Inactive' },
  { id: 'PENDING', name: 'Pending' },
];
export const statusesEnum = {
  'ACTIVE': 'ACTIVE',
  'INACTIVE': 'INACTIVE',
  'PENDING': 'PENDING',
};

